import { render } from "./SectionServicos.vue?vue&type=template&id=71ad224e&scoped=true"
import script from "./SectionServicos.vue?vue&type=script&lang=js"
export * from "./SectionServicos.vue?vue&type=script&lang=js"

import "./SectionServicos.vue?vue&type=style&index=0&id=71ad224e&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ad224e"]])

export default __exports__